<template>
  <div
    class="rounded-md grid gap-16 bg-[white]/25 p-12 transition-colors duration-[var(--raw-fast)] ease-[var(--raw-ease-out-quart)] active:bg-[white]/50 md:hover:bg-[white]/50"
  >
    <!-- Image + Title -->
    <div class="flex items-center gap-12 md:gap-16">
      <RevIllustration
        :src="article.image"
        :width="96"
        :height="54"
        alt=""
        aria-hidden="true"
        loading="lazy"
        class="aspect-video rounded-[4px] object-cover"
      />
      <h2 class="raw-heading-4 line-clamp-2 max-w-[30ch] text-balance">
        {{ i18n(article.title) }}
      </h2>
    </div>

    <!-- Meta -->
    <div class="flex gap-8">
      <span
        v-if="article.region[0]"
        class="raw-body-3 rounded-full flex h-24 items-center bg-[white]/50 px-8"
      >
        <RegionLabel :region="article.region[0]" />
      </span>

      <button
        type="button"
        class="raw-body-3 rounded-full flex h-24 items-center gap-8 bg-[white]/50 p-2 ps-8 transition-colors duration-[var(--raw-fast)] ease-[var(--raw-ease-out-quart)] hover:bg-[color-mix(in_oklab,var(--raw-lightgrey)_75%,transparent)] active:bg-[color-mix(in_oklab,var(--raw-lightgrey)_75%,transparent)]"
        @click.stop="openMetal()"
      >
        <span class="line-clamp-1">
          {{ i18n(article.metal.name) }}
        </span>
        <RevIllustration
          src="/mine-my-phone/icons/right--flat.svg"
          :width="20"
          :height="20"
          alt=""
          aria-hidden="true"
          class="rounded-full bg-[white] p-4"
        />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevIllustration } from '@ds/components/Illustration'

import RegionLabel from '~/scopes/campaign/components/impacts/RegionLabel.vue'
import { useModalState } from '~/scopes/campaign/composables/useModalState'
import type { Article } from '~/scopes/campaign/data/articles/data'

const props = defineProps<{ article: Article }>()

const i18n = useI18n()
const { trackClick } = useTracking()
const { openMetalQuickView } = useModalState()

// One host (the impacts panel's list), so the zone is its own rather than a prop.
function openMetal() {
  const { slug } = props.article.metal
  trackClick({
    zone: 'modal-impacts',
    name: 'metal-chip',
    slug,
    campaign: 'raw-materials',
  })
  openMetalQuickView(slug)
}
</script>
